import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faAlbum } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';

export function AlbumLabel({
  color = 'black',
  size = 's',
}: {
  color?: 'black' | 'white';
  size?: 's' | 'm';
}) {
  return (
    <div
      className={clsx(
        'flex items-center justify-center gap-x-1 rounded-[6px] ',
        color === 'black'
          ? 'bg-black font-medium text-white opacity-80'
          : 'bg-white font-normal text-black opacity-70',
        size === 'm' ? 'px-2 py-1 text-base-m' : 'px-1 py-0.5 text-base-s md:px-2 md:py-1',
      )}
    >
      <FontAwesomeIcon className="album-icon" icon={faAlbum} />
      <span
        className={clsx(
          'flex flex-col items-center justify-center font-kicker uppercase ',
          size === 'm' ? 'text-base-m' : 'text-base-xs',
        )}
      >
        Album
      </span>
    </div>
  );
}
